export class Unit {
    constructor(unitName, exponent) {
        this.unitName = unitName;
        this.exponent = exponent;
    }

    getDisplayName(){
        return this.unitName + "^" + this.exponent
    }
}

export class UnitsHelper {
    static unitsMap = new Map([
        ["CONCENTRATION", new Unit("kg m", -3)],
        ["DEPOSITION", new Unit("kg m", -2)],
        ["DOSAGE", new Unit("kg s m", -3)],
        ["ECT50", new Unit("", 0)],
        ["ICT50", new Unit("", 0)],
        ["LCT50", new Unit("", 0)],
        ["AEGL", new Unit("", 0)],
        ["INDOOR_CONCENTRATION", new Unit("kg m", -2)],
        ["INDOOR_DOSAGE", new Unit("kg s m", -3 )],
        ["BLAST", new Unit("psi", "")] ,
        ["ATP-45", new Unit("", "")],
        ["CED_WORKER_SLOW_LUNG_CLASS", new Unit("msv", "")],
        ["CED_WORKER_MED_LUNG_CLASS", new Unit("msv", "")],
        ["CED_WORKER_FAST_LUNG_CLASS", new Unit("msv", "")],
        ["CED_WORKER_VAPOUR", new Unit("msv", "")],
        ["CED_WORKER_INERT", new Unit("msv", "")],
        ["CED_ADULT_SLOW_LUNG_CLASS", new Unit("msv", "")],
        ["CED_ADULT_MED_LUNG_CLASS", new Unit("msv", "")],
        ["CED_ADULT_FAST_LUNG_CLASS", new Unit("msv", "")],
        ["CED_ADULT_INERT", new Unit("msv", "")],
        ["CED_15_YEAR_OLD_SLOW_LUNG_CLASS", new Unit("msv", "")],
        ["CED_15_YEAR_OLD_MED_LUNG_CLASS", new Unit("msv", "")],
        ["CED_15_YEAR_OLD_FAST_LUNG_CLASS", new Unit("msv", "")],
        ["CED_15_YEAR_OLD_INERT", new Unit("msv", "")],
        ["CED_10_YEAR_OLD_SLOW_LUNG_CLASS", new Unit("msv", "")],
        ["CED_10_YEAR_OLD_MED_LUNG_CLASS", new Unit("msv", "")],
        ["CED_10_YEAR_OLD_FAST_LUNG_CLASS", new Unit("msv", "")],
        ["CED_10_YEAR_OLD_INERT", new Unit("msv", "")],
        ["CED_5_YEAR_OLD_SLOW_LUNG_CLASS", new Unit("msv", "")],
        ["CED_5_YEAR_OLD_MED_LUNG_CLASS", new Unit("msv", "")],
        ["CED_5_YEAR_OLD_FAST_LUNG_CLASS", new Unit("msv", "")],
        ["CED_5_YEAR_OLD_INERT", new Unit("msv", "")],
        ["CED_1_YEAR_OLD_SLOW_LUNG_CLASS", new Unit("msv", "")],
        ["CED_1_YEAR_OLD_MED_LUNG_CLASS", new Unit("msv", "")],
        ["CED_1_YEAR_OLD_FAST_LUNG_CLASS", new Unit("msv", "")],
        ["CED_1_YEAR_OLD_INERT", new Unit("msv", "")],
        ["CED_INFANT_SLOW_LUNG_CLASS", new Unit("msv", "")],
        ["CED_INFANT_MED_LUNG_CLASS", new Unit("msv", "")],
        ["CED_INFANT_FAST_LUNG_CLASS", new Unit("msv", "")],
        ["CED_INFANT_INERT", new Unit("msv", "")]
    ]);

    /**
     * Returns the definition of a given unit
     * 
     * @param {*} unitType 
     * @returns Unit
     */
    static getUnits(unitType) {

        if(unitType === "" || unitType === undefined){
            console.log("Trying to get empty unit.")
            return new Unit("", "");
        }
        const unit = this.unitsMap.get(unitType);

        if(unit === undefined || unit.unitName === ""){
            return new Unit("", "");
        } else {
            return unit;
        }
    }
}